import { Box, Button, Modal, ThemeProvider, Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { useAppDispatch } from "../redux/hooks";
import { commonActions } from "../redux/features/common/commonSlice";
import theme from "../theme";
import { ROUTES } from "../constants/routes";

const ModalUtility = (props:any) => {
    const {msg, modalOpen, setModalOpen, isReloadNeeded, redirectToMaintenancePage} = props;

    const dispatch = useAppDispatch();
    const[t] = useTranslation();

    const reloadRequired = isReloadNeeded ? isReloadNeeded : false;
    const openMaintenancePage = redirectToMaintenancePage ?? false;


    const closeModal = () =>{
        if(reloadRequired){
            // dispatch(commonActions.IS_NEW_SELLER_LOGIN(false));
            window.close() ;
            window.location.reload();
            if(openMaintenancePage){
                window.location.href = ROUTES.UNDER_MAINTENANCE;
            }
        }else{
            setModalOpen(false);
        }
    };
    
    return (
        <>
            <ThemeProvider theme={theme}>
                <Modal
                    open={modalOpen}
                    // onClose={closeModal}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box className="center-model model_content" sx={{outline : "none"}}>
                        <Typography
                            id="modal-modal-title"
                            variant="h6"
                            component="h2"
                            sx={{ fontSize: "15px" }}
                        >{msg}</Typography>                 
                        <Button sx={{ mt: 2 ,lineHeight: "0.75", minWidth: "1px",}} onClick={closeModal}>
                            {t("OK")}
                        </Button> 
                    </Box>
                </Modal>
            </ThemeProvider>
        </>
    );
};

export default ModalUtility;